import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./top.css";
import AdvancedPasteModal from "./AdvancedPasteModal";
import RulerControls from "./RulerControls"; // ✅ Import your component
import UploadIcon from "@mui/icons-material/Upload";
import DownloadIcon from "@mui/icons-material/Download";
import AddIcon from "@mui/icons-material/Add";
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import FitScreenIcon from "@mui/icons-material/FitScreen";
import HomeIcon from "@mui/icons-material/Home";
import OpenWithIcon from "@mui/icons-material/OpenWith";
import DeleteIcon from "@mui/icons-material/Delete";
import ProjectManager from "../canvas/ProjectManager";
import Tooltip from "@mui/material/Tooltip";
import RotateRightIcon from "@mui/icons-material/RotateRight"; // Right Move
import RotateLeftIcon from "@mui/icons-material/RotateLeft"; // Left Move
import FlipIcon from '@mui/icons-material/Flip'; // Mirror X
import FlipCameraAndroidIcon from '@mui/icons-material/FlipCameraAndroid'; // Mirror Y
import FolderSpecialRoundedIcon from "@mui/icons-material/FolderSpecialRounded";
import layoutEngine from "../libraries/layoutEngine";
import InsertLinkIcon from "@mui/icons-material/InsertLink"; // for instance
import InstanceInsertForm from "./InstanceInsertForm"; // 👈 Make sure file exists
import hierarchyManager from "../libraries/HierarchyManager";
import labelLibrary from "../libraries/LabelLibrary"; // Import label library
// import layoutEngine from '../libraries/layoutEngine';
import ContentPasteGoIcon from "@mui/icons-material/ContentPasteGo"; // new advanced paste icon
import ToolManager from "../libraries/ToolManager.js";
import MissingLayersModal from "./popups/MissingLayersModal.jsx";

// import { addCell } from "../libraries/layoutEngine"; // Import addCell function
import layerLibrary from "../canvas/LayerLibrary";
import DesignPicker from "./DesignPicker.jsx";


const TopBar = () => {
  const [designName, setDesignName] = React.useState(
    ProjectManager.getTopCellName()
  );
  const [cellName, setCellName] = useState(ProjectManager.getSelectedCell() || ProjectManager.getTopCellName());

  console.log(JSON.stringify(layoutEngine.getCells(), null, 2));
  const [activeTool, setActiveTool] = React.useState(ProjectManager.getTool());

  // for instance variable
  const [selectedFile, setSelectedFile] = useState(null);
  const [showAddCellModal, setShowAddCellModal] = useState(false);
  const [missingLayers, setMissingLayers] = useState([]);
  const [showMissingPopup, setShowMissingPopup] = useState(false);

  useEffect(() => {
  if (showMissingPopup && missingLayers.length === 0) {
    setShowMissingPopup(false);
  }
}, [missingLayers, showMissingPopup]);


  const [newCellName, setNewCellName] = useState("");
  const designPickerRef = useRef(null);

  const [showAdvancedPaste, setShowAdvancedPaste] = useState(false);
  const [gridConfig, setGridConfig] = useState({
  rows: 1,
  cols: 1,
  posX: 0,
  posY: 0,
  rowSpacing: 100,
  colSpacing: 100,
});

const handleApply = () => {
    window.canvasEngine.advancedPaste(
      gridConfig.rows,
      gridConfig.cols,
      gridConfig.posX,
      gridConfig.posY,
      gridConfig.rowSpacing,
      gridConfig.colSpacing
    );
    setShowAdvancedPaste(false);
  };


  

  // const [gdsData, setGdsData] = useState(null);
  const [showInstanceForm, setShowInstanceForm] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  //shiv code effect for tool change fetch
  // useEffect(() => {
  //   const handleToolChange = (e) => {
  //     setActiveTool(e.detail); // Update state when event is received
  //   };

  //   window.addEventListener("tool-changed", handleToolChange);

  //   // Set initial tool on load
  //   setActiveTool(ProjectManager.getTool());

  //   return () => {
  //     window.removeEventListener("tool-changed", handleToolChange);
  //   };
 // }, []);
  // 🔁 Dropdown select → NO picker. Server se file uthaao, phir EXACT same success-block chalao.
  useEffect(() => {
    async function onDesignPicked(e) {
      const { dir, gds, cf, err, kind, name } = e.detail || {};
      if (!dir || !gds) return;
      try {
        // ✅ Backend ko bolo ki selected dir se GDS uthaa ke
        //    EXACT SAME response shape bheje jo /upload-gds-instance deta hai.
        const resp = await axios.post(`${API_BASE_URL}/upload-gds-from-dir`, { dir, gds });

        // 🔁 BELOW: paste the SAME success block as file-upload
        //const jsonData = resp.data?.data?.layout_data;
        const jsonData = resp.data.data.layout_data;
        console.log("json data", jsonData)
        if (!jsonData) throw new Error("layout_data missing");
        window.newunit = resp.data.data.layout_data || 1;
        const userSize = jsonData.units.user_size;
        
        console.log("userSize", userSize)
        const db_size = jsonData?.units?.db_size;
        const dbu = db_size / userSize;
        const my_usersize = 1e-06;
        const new_usersize = my_usersize / userSize;
        window.new_usersize = new_usersize;
        const my_dbsize = 1e-10;
        const new_dbsize = my_dbsize / db_size;
        window.new_dbsize = new_dbsize;
        await layerLibrary.ensureLoaded();
        layoutEngine.loadFromGDS(jsonData.cells, dbu * new_usersize * new_dbsize);
        if (jsonData.cells?.length > 0) {
          const topCell = jsonData.cells[0].name;
          ProjectManager.setTopCellName(topCell);
          ProjectManager.setSelectedCell(topCell);
          hierarchyManager.addCell(topCell);
          window.canvasEngine.useUploadedCells = true;
        }
        window.canvasEngine.draw();


        // after successful GDS load block, append:





        // ✅ Auto-load .cf using the SAME path as Upload.js (no DOM / no picker)
       // ✅ Auto-load .cf using the SAME path as Upload.js (no DOM / no picker)
if (cf) {
  try {
    // ---- 0) Mount comm panel first (so FR exists) ----------------
    try {
      ToolManager.setTool("bug&imp");
      window.dispatchEvent(new CustomEvent("tool-changed", { detail: "bug&imp" }));
    } catch (_) {}

    // Optional: propagate username early
    try {
      const uid = localStorage.getItem("candidateId") || "Candidate";
      window.canvasEngine?.FeatureRenderer?.updateUsername?.(uid);
    } catch (_) {}

    // ---- 1) Read + parse CF text ---------------------------------
    const cfResp = await axios.post(`${API_BASE_URL}/communication-from-dir`, { dir, cf });
    const cfText = cfResp?.data?.text;
    if (!cfText) throw new Error("Empty CF text");

    const importedData = JSON.parse(cfText);
    if (!importedData?.bug || !importedData?.improvement || !importedData?.query) {
      throw new Error("Invalid .cf file structure");
    }

    // ---- 2) Resolve CF→cell name + verify it exists ---------------
    const cfBase = String(cf).replace(/\\/g, "/").split("/").pop();
    const cfNameNoExt = cfBase.replace(/\.cf$/i, "");

    const loadedCellNames = (resp?.data?.data?.layout_data?.cells || []).map(c => c.name);
    if (!loadedCellNames.includes(cfNameNoExt)) {
      alert(`⚠️  "${cfNameNoExt}" cell not present in loaded GDS. CF skipped.`);
      return;
    }

    // ---- 3) PM selection first -----------------------------------
    ProjectManager.setTopCellName(cfNameNoExt);
    ProjectManager.setSelectedCell(cfNameNoExt);
    window.dispatchEvent(new Event("cell-changed"));
    window.canvasEngine?.draw?.();

    // ---- 4) Wait for panel DOM + FR object -----------------------
    const waitFor = async (fn, timeout = 8000, step = 120) => {
      const t0 = Date.now();
      while (Date.now() - t0 < timeout) {
        try { const v = fn(); if (v) return v; } catch (_) {}
        await new Promise(r => setTimeout(r, step));
      }
      return null;
    };
    await waitFor(() => document.querySelector(".report-container"), 6000, 100);
    const fr = await waitFor(() => window.canvasEngine?.FeatureRenderer, 6000, 120);
    if (!fr) throw new Error("FeatureRenderer not ready");

    // ---- 5) HARD-SET FR’s active cell (multiple fallbacks) -------
    const setFRCell = (name) => {
      let ok = false;
      try { if (typeof fr.setActiveCell === "function") { fr.setActiveCell(name); ok = true; } } catch (_) {}
      try { if (!ok && typeof fr.setCell === "function") { fr.setCell(name); ok = true; } } catch (_) {}
      try { if (!ok && typeof fr.selectCell === "function") { fr.selectCell(name); ok = true; } } catch (_) {}
      try { if (!ok && "activeCellName" in fr) { fr.activeCellName = name; ok = true; } } catch (_) {}
      try { if (!ok && "activeCell" in fr) { fr.activeCell = name; ok = true; } } catch (_) {}
      return ok;
    };
    setFRCell(cfNameNoExt);

    // nudge FR listeners
    fr.emitSceneUpdate?.();
    window.dispatchEvent(new Event("cell-changed"));
    window.canvasEngine?.draw?.();

    // ---- 6) Deterministic check of FR's active cell --------------
    const getFRCell = () => {
      try { if (typeof fr.getActiveCell === "function") return fr.getActiveCell(); } catch (_) {}
      try { if (typeof fr.getActiveCellName === "function") return fr.getActiveCellName(); } catch (_) {}
      try { if (typeof fr.activeCellName === "string") return fr.activeCellName; } catch (_) {}
      try { if (typeof fr.activeCell === "string") return fr.activeCell; } catch (_) {}
      return null;
    };
    const okFRCell = await waitFor(() => {
      const v = getFRCell();
      return v && v === cfNameNoExt;
    }, 2000, 100);

    if (!okFRCell) {
      // last push if still null
      setFRCell(cfNameNoExt);
      fr.emitSceneUpdate?.();
      window.dispatchEvent(new Event("cell-changed"));
      window.canvasEngine?.draw?.();
      await new Promise(r => setTimeout(r, 250));
    }

    console.log("[CF-UPLOAD] FR activeCell (pre-upload):", getFRCell?.());
    console.log("[CF-UPLOAD] PM selectedCell:", ProjectManager.getSelectedCell());
    console.log("[CF-UPLOAD] PM topCellName:", ProjectManager.getTopCellName());

    // ---- 7) Try uploadJSON with multiple signatures --------------
    const tryUpload = async (data, cell, attempts = 6) => {
      const calls = [
        () => fr.uploadJSON?.(data),                          // plain
        () => fr.uploadJSON?.(data, cell),                    // (data, "cell")
        () => fr.uploadJSON?.(data, { cell }),                // (data, {cell})
        () => fr.uploadJSON?.({ ...data, __cell: cell }),     // baked field
      ];
      for (let i = 0; i < attempts; i++) {
        for (const call of calls) {
          try {
            const ok = call();
            if (ok) return true;
          } catch (_) {}
        }
        // re-sync between attempts
        setFRCell(cell);
        ProjectManager.setSelectedCell(cell);
        window.dispatchEvent(new Event("cell-changed"));
        fr.emitSceneUpdate?.();
        window.canvasEngine?.draw?.();
        await new Promise(r => setTimeout(r, 250 + i * 150));
      }
      return false;
    };

    const ok = await tryUpload(importedData, cfNameNoExt, 6);
    if (!ok) {
      console.warn("[CF-UPLOAD] uploadJSON returned false", {
        frCell: getFRCell?.(),
        selected: ProjectManager.getSelectedCell(),
        top: ProjectManager.getTopCellName(),
      });
      throw new Error("uploadJSON() returned false");
    }

    // ---- 8) Final broadcast -------------------------------------
    fr.emitSceneUpdate?.();
    console.log("✅ CF loaded via uploadJSON()");
  } catch (err) {
    console.error("Auto CF upload failed:", err);
  }
}
        // 🔹 NEW: Auto-load DRC .err (if present in picked item)
        if (err) {
          try {
            const { data } = await axios.post(
              `${API_BASE_URL}/drc-from-dir`,
              { dir, err }
            );
            const rawText = data?.text || "";
            // .err could be plain text or JSON (your generator), try parse but don't force
            let json = null;
            try { json = JSON.parse(rawText); } catch (_) {}

            // Broadcast to DRC Viewer — it can consume either raw or json
            window.dispatchEvent(
              new CustomEvent("drc-file-loaded", {
                detail: {
                  raw: rawText,
                  json,
                  source: { dir, err, name, kind: kind || "drc" },
                },
              })
            );
            // (optional) ask UI to open/bring DRC panel to front
            window.dispatchEvent(new Event("open-right-panel"));
            window.dispatchEvent(new CustomEvent("open-drc-viewer"));
          } catch (e) {
            console.error("ERR load failed:", e);
          }
        }
      } catch (err) {
        console.error("Design select failed:", err);
        alert(`Design load failed: ${err?.response?.data?.error || err.message}`);
      }
    }
    window.addEventListener("design-picked", onDesignPicked);
    return () => window.removeEventListener("design-picked", onDesignPicked);
  }, [API_BASE_URL]);
  useEffect(() => {
  const handleToolChange = (e) => {
    setActiveTool(e.detail);
  };
  

  const handleCellChange = () => {
    setCellName(ProjectManager.getSelectedCell() || ProjectManager.getTopCellName());
  };

  // listeners
  window.addEventListener("tool-changed", handleToolChange);
  window.addEventListener("cell-changed", handleCellChange);

  // initialize values
  setActiveTool(ProjectManager.getTool());
  setCellName(ProjectManager.getSelectedCell() || ProjectManager.getTopCellName());

  return () => {
    window.removeEventListener("tool-changed", handleToolChange);
    window.removeEventListener("cell-changed", handleCellChange);
  };
}, []);


  // 🔽 NEW util – returns every cell that is currently in memory
const downloadGds = async () => {
    const USER_SIZE = 1e-06;
    const DB_SIZE = 1e-10;
    const SCALE = 1; // ✅ 0.1
    // 👈 Yeh value tu dynamic bhi bana sakta hai if needed

    const createdCells = layoutEngine.getCells();
    const uploadedCells = layoutEngine.getUploadedCells();
    const allCells = [...createdCells, ...uploadedCells];

    if (!allCells.length) {
      alert("⚠️  No layout to download");
      return;
    }

    const allCellMap = {};
    allCells.forEach((cell) => {
      allCellMap[cell.name] = cell;
    });

    const formattedSet = new Set();
    const formattedCells = [];

    const applyTransform = (x, y, transform) => {
      const angle = ((transform.rotation || 0) * Math.PI) / 180;
      const cos = Math.cos(angle);
      const sin = Math.sin(angle);
      const newX = transform.x + (x * cos - y * sin);
      const newY = transform.y + (x * sin + y * cos);
      return { x: newX, y: newY };
    };


  

    const getCellCenter = (cell) => {
      const rects = cell.elements?.filter((e) => e.type === "rectangle") || [];
      if (!rects.length) return { x: 0, y: 0 };

      let minX = Infinity,
        maxX = -Infinity,
        minY = Infinity,
        maxY = -Infinity;
      rects.forEach((el) => {
        minX = Math.min(minX, el.x);
        maxX = Math.max(maxX, el.x + el.width);
        minY = Math.min(minY, el.y);
        maxY = Math.max(maxY, el.y + el.height);
      });

      return {
        x: (minX + maxX) / 2,
        y: (minY + maxY) / 2,
      };
    };

    const formatCellForGDS = (
      cell,
      parentTransform = { x: 0, y: 0, rotation: 0 }
    ) => {
      const isUploaded = uploadedCells.some((c) => c.name === cell.name);
      const properties = [];

      // Rectangles
      for (const el of cell.elements || []) {
        console.log("el type", el.type);
        if (el.type === "rectangle") {
          const layerNum = parseInt(el.layer, 10);

          if (!Number.isFinite(layerNum)) {
            console.warn("Skipping rectangle (invalid layer):", el);
            continue;
          }
          const coords = [
            [el.x * SCALE, -el.y * SCALE],
            [(el.x + el.width) * SCALE, -el.y * SCALE],
            [(el.x + el.width) * SCALE, (-el.y - el.height) * SCALE],
            [el.x * SCALE, (-el.y - el.height) * SCALE],
          ];
          properties.push({
            type: "Rectangle",
            coordinates: coords,
            layer: parseInt(el.layer),
            datatype: parseInt(el.datatype) || 0,
          });
        }
        if (el.type === "polygon") {
          const layerNum = parseInt(el.layer, 10);

        if (!Number.isFinite(layerNum)) {
          console.warn("Skipping polygon (invalid layer):", el);
          continue;
        }
          const rawPoints = el.points || [];
          const coords = rawPoints
            .filter((pt) => Array.isArray(pt) && pt.length === 2)
            .map(([x, y]) => [x * SCALE, -y * SCALE]);

          // ✅ Remove duplicate last point if needed
          if (
            coords.length > 2 &&
            coords[0][0] === coords[coords.length - 1][0] &&
            coords[0][1] === coords[coords.length - 1][1]
          ) {
            coords.pop();
          }

          properties.push({
            type: "Polygon",
            coordinates: coords,
            layer: parseInt(el.layer) || 1, // ✅ Force number
            datatype: parseInt(el.datatype) || 0, // ✅ Force number
          });
        }
      }

      // Labels
      // Labels
      const labels = labelLibrary.getAllLabels(cell.name) || [];
      for (const label of labels) {
        // 🔽 Robust layer/datatype extraction
        const lid =
          label.layerId ||
          `${label.layerNumber ?? label.layer}:${
            label.datatypeNumber ?? label.datatype ?? 0
          }`;
          
        const [L, D = "0"] = String(lid).split(":");
        const layerNum = Number.isFinite(parseInt(L, 10)) ? parseInt(L, 10) : 0;
        const dataNum = Number.isFinite(parseInt(D, 10)) ? parseInt(D, 10) : 0;

        if (!Number.isFinite(layerNum)) {
          console.warn("Skipping label (invalid layer):", label);
          continue;
        }

        properties.push({
          type: "Text",
          text: label.text || "",
          coordinates: [[label.x * SCALE, -label.y * SCALE]],
          rotation: Number.isFinite(+label.rotation) ? +label.rotation : 0,
          layer: layerNum, // ✅ always a number
          datatype: dataNum, // ✅ always a number
        });
      }

      // Instances
      for (const inst of cell.instances || []) {
        if (inst.ref) {
          const transformed = applyTransform(inst.x, inst.y, parentTransform);

          let origin = [transformed.x * SCALE, -transformed.y * SCALE];

          const childCell = allCellMap[inst.ref];

          // Adjust created only
          const isChildUploaded = uploadedCells.some(
            (c) => c.name === inst.ref
          );
          if (!isChildUploaded && childCell) {
            const center = getCellCenter(childCell);
            origin = [
              (transformed.x - center.x) * SCALE,
              -(transformed.y - center.y) * SCALE,
            ];
          }

          // properties.push({
          //   type: "Instance",
          //   text: inst.ref,
          //   origin: [origin],
          //   rotation: inst.rotation || 0,
          //   mirror_x: inst.mirror_x,
          //   mirror_y: inst.mirror_y
          // });
          // --- INSTANCE EXPORT FIX (handles mirror_y correctly) ---
let outInst = {
  type: "Instance",
  text: inst.ref,
  rotation: inst.rotation || 0,

  // we ALWAYS export mirror_x only
  mirror_x: inst.mirror_x ? true : false,

  // keep mirror_y flag for frontend even if backend ignores it
  mirror_y: inst.mirror_y ? true : false
};

// compute origin normally
let o = [origin[0], origin[1]];

// --- If instance was mirror-Y ---
if (inst.mirror_y) {

  // backend understands only mirror_x, so convert Y → X + 180° rotation
  outInst.mirror_x = true;

  outInst.rotation = ((outInst.rotation + 180) % 360);

  // Flip exported Y coordinate
  o = [o[0], -o[1]];
}

outInst.origin = [o];
properties.push(outInst);


          if (childCell && !formattedSet.has(inst.ref)) {
            const nextTransform = {
              x: transformed.x,
              y: transformed.y,
              rotation: (parentTransform.rotation || 0) + (inst.rotation || 0),
            };
            formattedSet.add(inst.ref);
            formattedCells.push(formatCellForGDS(childCell, nextTransform));
          }
        }
      }

      return {
        cellname: cell.name,
        properties,
      };
    };

    Object.values(allCellMap).forEach((cell) => {
      if (!formattedSet.has(cell.name)) {
        formattedSet.add(cell.name);
        formattedCells.push(formatCellForGDS(cell));
      }
    });

    const finalJson = {
      data: {
        layout_data: {
          units: {
            user_size: 1e-06,
            db_size: 1e-10,
          },
          cells: formattedCells,
        },
      },
    };

    console.log(JSON.stringify(finalJson, null, 2));

    try {
      const blob = new Blob([JSON.stringify(finalJson)], {
        type: "application/json",
      });

      const formData = new FormData();
      formData.append("file", blob, "layout.json");

      const res = await fetch(`${API_BASE_URL}/convert-json-to-gds`, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) throw new Error("Server responded " + res.status);

      const gdsBlob = await res.blob();
      const url = window.URL.createObjectURL(gdsBlob);

      const a = document.createElement("a");
      a.href = url;
      // a.download = `${ProjectManager.getDesignName() || "layout"}.gds`;
      const fileName = ProjectManager.getTopCellName() || "layout";
      a.download = `${fileName}.gds`;

      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
      alert("❌ Couldn’t download GDS – check console / server logs");
    }
  };
  const handleFitToScreen = () => {
    const ce = window.canvasEngine;
    if (!ce) return;
    const fn =
      ce.fitToScreen ||
      ce.fitToWindow ||
      ce.zoomToFit ||
      ce.fitToView ||
      ce.fitView ||
      ce.fitToViewBox;
    if (typeof fn === "function") fn.call(ce);
    else window.dispatchEvent(new CustomEvent("fit-to-screen"));
  };
  // end shiv code
  
  return (
    <header className="top-bar">
      <div className="logo-and-icons">
        <div className="logo">
          <b style={{ color: "green" }}>IC</b>urate-layout
        </div>

        <div className="icon-bar">
          <Tooltip title="Upload">
            <UploadIcon
              fontSize="small"
              onClick={() => document.getElementById("gds-upload").click()}
            />
            <input
              type="file"
              id="gds-upload"
              accept=".gds"
              style={{ display: "none" }}
              onChange={async (e) => {
                const file = e.target.files[0];
                if (!file) return;

                setSelectedFile(file);

                const formData = new FormData();
                formData.append("file", file);

                try {
                  const response = await axios.post(
                    `${API_BASE_URL}/upload-gds-instance`,
                    formData,
                    {
                      headers: {
                        "Content-Type": "multipart/form-data",
                      },
                    }
                  );

                  const jsonData = response.data.data.layout_data;

                  // console.log("Server response:", jsonData);

                  // ✅ Load cells
                  window.newunit=response.data.data.layout_data || 1
                  //layoutEngine.loadCellsFromJSON(jsonData.cells);
                  const userSize = jsonData?.units?.user_size;
                  const db_size = jsonData?.units?.db_size;

                  const dbu= db_size/ userSize
                 

                 const my_usersize = 1e-06
                 const new_usersize= my_usersize/ userSize
                  window.new_usersize = new_usersize;  // ✅ expose globally
                const my_dbsize= 1e-10
                 const new_dbsize = my_dbsize/ db_size
                 window.new_dbsize = new_dbsize;  // ✅ expose globally
                  await layerLibrary.ensureLoaded();

                  layoutEngine.loadFromGDS(jsonData.cells, dbu  * new_usersize* new_dbsize);
                  // ✅ Select first cell (usually "TOP")
                  if (jsonData.cells.length > 0) {
                    const topCell = jsonData.cells[0].name;
                    ProjectManager.setTopCellName(topCell); // 🔥 required for hierarchy base
                    ProjectManager.setSelectedCell(topCell); // 🔥 required for canvas render
                    hierarchyManager.addCell(topCell);
                    window.canvasEngine.useUploadedCells = true; // ✅ ENABLE GDS RENDERING
                  }

                  // ✅ Redraw canvas
                  window.canvasEngine.draw();
                  // after successful GDS load + draw
                  const usedLayerIds = layerLibrary.getUsedLayerIdsFromLayout();
                  const missing = layerLibrary.getMissingLayersFromUsed(usedLayerIds);

                if (missing.length > 0) {
                  setMissingLayers(missing);
                  setShowMissingPopup(true);
                }


                } catch (error) {
                  console.error("Upload failed:", error);
                }
              }}
            />
          </Tooltip>
          <Tooltip title="Download">
            <DownloadIcon fontSize="small" onClick={downloadGds} />
          </Tooltip>
          <Tooltip title="Create New Cell">
            <AddIcon
              fontSize="small"
              onClick={() => setShowAddCellModal(true)}
            />
          </Tooltip>
          <Tooltip title="Undo">
            <UndoIcon
              fontSize="small"
              onClick={() => window.canvasEngine.undo()}
            />
          </Tooltip>
          <Tooltip title="Redo">
            <RedoIcon
              fontSize="small"
              onClick={() => window.canvasEngine.redo()}
            />
          </Tooltip>
          <Tooltip title="Copy">
            <ContentCopyIcon
              fontSize="small"
              onClick={() => window.canvasEngine.copySelectedObjects()}
            />
          </Tooltip>
          <Tooltip title="Paste">
            <NoteAltIcon
              fontSize="small"
              onClick={() => window.canvasEngine.pasteCopiedObjects()}
            />
          </Tooltip>
          <Tooltip title="Advanced Paste">
            <ContentPasteGoIcon
            fontSize="small"
            onClick={() => setShowAdvancedPaste(true)}
            style={{ cursor: "pointer" }}
            />
          </Tooltip>

          {/* <Tooltip title="Scan Document">
            <DocumentScannerIcon fontSize="small" />
          </Tooltip> */}
          <Tooltip title="Home">
            <HomeIcon
              fontSize="small"
              onClick={() => {
                if (window.canvasEngine?.goHome) window.canvasEngine.goHome();
                else window.dispatchEvent(new CustomEvent("go-home"));
              }}
              style={{ cursor: "pointer" }}
            />
          </Tooltip>
          <Tooltip title="Fit to Screen">
            <FitScreenIcon fontSize="small" onClick={handleFitToScreen} />
          </Tooltip>
          <Tooltip title="Move">
            <OpenWithIcon
              fontSize="small"
              onClick={() => window.canvasEngine.enterMultiMoveMode()}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <DeleteIcon
              fontSize="small"
              onClick={() => window.canvasEngine.deleteSelectedObjects()}
            />
          </Tooltip>
          <Tooltip title="Add Instance">
            <InsertLinkIcon
              fontSize="small"
              onClick={() => setShowInstanceForm(true)}
            />
          </Tooltip>

          <Tooltip title="Sample Designs">
          <FolderSpecialRoundedIcon
            fontSize="small"
            onClick={() => designPickerRef.current?.toggle()}
            style={{ cursor: "pointer" }}
          />
          </Tooltip>
        </div>

        <div style={{ position: "relative" }}>
          <DesignPicker ref={designPickerRef} hideButton closeOnOutsideOrEsc={false} />
        </div>
        {/* shiv code */}
        {activeTool === "select" && (
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              marginLeft: "20px",
              padding: "5px",
              border: "1px solid #444",
              borderRadius: "8px",
              backgroundColor: "#2b2b2b",
            }}>
            <Tooltip title="Rotate Right">
              <RotateRightIcon
                fontSize="small"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.dispatchEvent(new CustomEvent("rotate-right"))
                }
              />
            </Tooltip>
            <Tooltip title="Rotate Left">
              <RotateLeftIcon
                fontSize="small"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.dispatchEvent(new CustomEvent("rotate-left"))
                }
              />
            </Tooltip>
            <Tooltip title="Mirror X">
            <FlipIcon fontSize="small" style={{ cursor: 'pointer' }} onClick={() => window.dispatchEvent(new CustomEvent("mirror-x"))}/>
          </Tooltip>
          <Tooltip title="Mirror Y">
            <FlipCameraAndroidIcon fontSize="small" style={{ cursor: 'pointer' }} onClick={() => window.dispatchEvent(new CustomEvent("mirror-y"))}/>
          </Tooltip>
          </div>
        )}
        {activeTool === "ruler" && <RulerControls />}
      </div>
      <div
        style={{
          marginLeft: "auto",
          marginRight: "7px",
          display: "flex",
          alignItems: "center",
        }}
        >
          <Tooltip title="Current Cell Name">
        <input
          type="text"
          value={cellName}
          onChange={(e) => {
          ProjectManager.setSelectedCell(e.target.value); 
          setCellName(e.target.value);
          }}
          placeholder="Enter Design Name"
          style={{
            padding: "10px",
            width: '180px',
            height: "10px",
            right: "0px",
            fontSize: "14px",
            borderRadius: "4px",
            border: "1px solid #888",
            backgroundColor: "#222",
            color: "#fff",
            outline: "none",
            maxWidth: "200px",
          }}
        />
      </Tooltip>
      </div>

      {showAddCellModal && (
  <div
    className="modal-overlay"
    onClick={() => setShowAddCellModal(false)}
  >
    <div
      className="modal-card"
      role="dialog"
      aria-modal="true"
      aria-labelledby="add-cell-title"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-title" id="add-cell-title">Create New Cell</div>

      <input
        className="modal-input"
        type="text"
        placeholder="Enter cell name"
        value={newCellName}
        autoFocus
        onChange={(e) => setNewCellName(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && newCellName.trim()) {
            layoutEngine.addCell(newCellName.trim());
            ProjectManager.setSelectedCell(newCellName.trim());
            alert(`✅ Cell '${newCellName}' created`);
            setNewCellName("");
            setShowAddCellModal(false);
            window.canvasEngine.draw();
          }
          if (e.key === "Escape") setShowAddCellModal(false);
        }}
      />

      <div className="modal-actions">
        <button
          className="btn-minimal"
          onClick={() => setShowAddCellModal(false)}
        >
          Cancel
        </button>
        <button
          className="btn-minimal btn-primary"
          disabled={!newCellName.trim()}
          onClick={() => {
            if (!newCellName.trim()) return;
            layoutEngine.addCell(newCellName.trim());
            ProjectManager.setSelectedCell(newCellName.trim());
            alert(`✅ Cell '${newCellName}' created`);
            setNewCellName("");
            setShowAddCellModal(false);
            window.canvasEngine.draw();
          }}
        >
          Create
        </button>
      </div>
    </div>
  </div>
)}


     {showInstanceForm && (
  <div className="modal-overlay" onClick={() => setShowInstanceForm(false)}>
    <div
      className="modal-card instance-modal"
      role="dialog"
      aria-modal="true"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-title">Insert Instance</div>

      {/* Keep your existing logic, just wrapped & simplified via CSS */}
      <InstanceInsertForm onClose={() => setShowInstanceForm(false)} />

      <div className="btn-row">
        <button className="btn-minimal" onClick={() => setShowInstanceForm(false)}>
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

    {showAdvancedPaste && (
        <AdvancedPasteModal
          gridConfig={gridConfig}
          setGridConfig={setGridConfig}
          onClose={() => setShowAdvancedPaste(false)}
          onApply={handleApply}
        />
)}

{showMissingPopup && (
  <MissingLayersModal
    layers={missingLayers}
    onClose={() => setShowMissingPopup(false)}
    onLayerAdded={(layer) => {
      setMissingLayers(prev =>
        prev.filter(
          l =>
            !(
              l.layer_number === layer.layer_number &&
              l.datatype_number === layer.datatype_number
            )
        )
      );
    }}
  />
)}




      
    </header>
  );
};

export default TopBar;
